// extracted by mini-css-extract-plugin
export var pageWrapper = "CategoryPage-module--pageWrapper--Qr7Lu";
export var postDeck = "CategoryPage-module--postDeck--3jyIi";
export var categoryHeading = "CategoryPage-module--categoryHeading--ZfSuc";
export var postDeckDesktop = "CategoryPage-module--postDeckDesktop--2wZIV";
export var postDeckColumn = "CategoryPage-module--postDeckColumn--2FdI8";
export var postDeckColumnLeft = "CategoryPage-module--postDeckColumnLeft--3K_n1";
export var postDeckColumnRight = "CategoryPage-module--postDeckColumnRight--2tlLY";
export var postDeckSeparator = "CategoryPage-module--postDeckSeparator--fEAlO";
export var postDeckSeparatorInner = "CategoryPage-module--postDeckSeparatorInner--1JbLs";